import * as Tone from "tone";
export class Synth {
  private static currentSynth: Tone.Sampler;
  public static init() {
    Synth.currentSynth = new Tone.Sampler(
      {
        "C1" : "samples/C1.mp3",
        "C2" : "samples/C2.mp3",
        "C3" : "samples/C3.mp3",
        "C4" : "samples/C4.mp3",
        "C5" : "samples/C5.mp3",
        "C6" : "samples/C6.mp3",
        // "D4" : "samples/D4.mp3",
        // "E4" : "samples/E4.mp3",
        // "F4" : "samples/F4.mp3",
        // "G4" : "samples/G4.mp3",
        // "A4" : "samples/A4.mp3",
        // "B4" : "samples/B4.mp3",
        // "C5" : "samples/C5.mp3",
      }
    ).toDestination();
  }

  public static playNote(note: string) {
    Synth.currentSynth.triggerAttackRelease(note, "8n");
  }

  public static noteDown(note: string) {
    Synth.currentSynth.triggerAttack(note);
  }

  public static noteUp(note: string) {
    Synth.currentSynth.triggerRelease(note);
  }
}